function activeRoundKey(boardSessionId) {
  return `mini_tasks_active_word_build:${boardSessionId}`;
}

function progressKey(roundId) {
  return `mini_tasks_word_build_progress:${roundId}`;
}

export function writeWordBuildLocalProgress(round, attempts) {
  try {
    window.localStorage.setItem(progressKey(round.round_id), JSON.stringify({ round, attempts }));
  } catch (_err) {
    // Keep the active play in memory if storage is unavailable.
  }
}

export function readWordBuildLocalProgress(roundId) {
  try {
    return JSON.parse(window.localStorage.getItem(progressKey(roundId)) || 'null');
  } catch (_err) {
    return null;
  }
}

export function clearWordBuildLocalProgress(roundId) {
  try {
    window.localStorage.removeItem(progressKey(roundId));
  } catch (_err) {
    // Ignore storage failures.
  }
}

export function writeActiveWordBuildRound(boardSessionId, roundId) {
  try {
    window.localStorage.setItem(activeRoundKey(boardSessionId), String(roundId));
  } catch (_err) {
    // Backend remains authoritative if local storage is unavailable.
  }
}

export function readActiveWordBuildRound(boardSessionId) {
  try {
    return window.localStorage.getItem(activeRoundKey(boardSessionId));
  } catch (_err) {
    return null;
  }
}

export function clearActiveWordBuildRound(boardSessionId) {
  try {
    window.localStorage.removeItem(activeRoundKey(boardSessionId));
  } catch (_err) {
    // Ignore storage failures.
  }
}
